<template>
  <div class="container">
    <div class="row statistics">
      <div class="col-md-7 first-div">
        <Statistics />
      </div>
      <div class="col-md-5 second-div">
        <h1 class="text-center">Query Page</h1>
        <p class="text-danger" v-if="!$isLoggedIn">
          Please login to use this form. Click
          <strong @click="openLoginModal" style="cursor: pointer">here</strong>
          to login
        </p>
        <form method="POST" @submit.prevent="processQuery">
          <div class="form-group">
            <label>Services</label>
            <multiselect
              v-model="selectedServices"
              placeholder="Search..."
              label="name"
              track-by="id"
              :options="initialServices"
              :multiple="true"
              :taggable="false"
              :max-height="150"
              :limit="4"
              :showLabels="false"
              :loading="isServicesLoading"
              :disabled="!$isLoggedIn"
            ></multiselect>
          </div>
          <div class="form-group">
            <label>Communities</label>
            <multiselect
              v-model="selectedCommunities"
              placeholder="Search..."
              label="name"
              track-by="id"
              :options="initialCommunities"
              :multiple="true"
              :taggable="false"
              :max-height="150"
              :limit="4"
              :showLabels="false"
              :loading="isCommunitiesLoading"
              :disabled="!$isLoggedIn"
            ></multiselect>
          </div>
          <div class="form-group">
            <label>Message</label>
            <textarea
              class="form-control"
              cols="30"
              rows="4"
              :disabled="!$isLoggedIn"
              v-model="form.message"
            ></textarea>
          </div>

          <div class="form-group mb-0">
            <b-row>
              <b-col>
                <div class="form-group">
                  <label>Approx time to start</label>
                  <br />
                  <b-dropdown
                    :text="form.time_to_start"
                    variant="outline-primary"
                    split
                    block
                    :disabled="!$isLoggedIn"
                  >
                    <b-dropdown-item
                      :key="index"
                      v-for="(value, index) in [
                        'Immediately',
                        'In coming 3 months',
                        'After 3 months'
                      ]"
                      @click="changeTimeToStart(value)"
                      >{{ value }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </b-col>
              <b-col>
                <div class="form-group">
                  <label>Preferred way to contact</label>
                  <br />
                  <b-dropdown
                    :text="form.contact_type"
                    variant="outline-primary"
                    split
                    block
                    :disabled="!$isLoggedIn"
                  >
                    <b-dropdown-item
                      :key="index"
                      v-for="(value, index) in ['Email', 'Phone']"
                      @click="changeContactType(value)"
                      >{{ value }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="form-group">
            <template v-if="form.contact_type === 'Phone'">
              <label>Phone</label>
              <input
                type="text"
                class="form-control"
                :disabled="!$isLoggedIn"
                v-model="form.phone"
              />
              <label class="mt-3">Preferred time to contact</label>
              <br />
              <b-time
                v-model="form.time"
                locale="en"
                @context="onContext"
                :disabled="!$isLoggedIn"
              ></b-time>
            </template>
            <template v-if="form.contact_type === 'Email'">
              <label>Email</label>
              <input
                type="text"
                class="form-control"
                :disabled="!$isLoggedIn"
                v-model="form.email"
              />
            </template>
          </div>
          <div class="form-group mb-0">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="!$isLoggedIn"
            >
              Submit Query
            </button>
          </div>
        </form>
        <hr />
        <p>API Payloads</p>
        <pre>{{ form }}</pre>
        <p>isAuthenticated: {{ $isLoggedIn }}</p>
      </div>
    </div>
    <b-modal
      id="login-modal"
      title="Login Account"
      centered
      :no-close-on-esc="true"
      :hide-footer="true"
      :no-close-on-backdrop="true"
    >
      <EmailLogin :resource="'query'" />
    </b-modal>
  </div>
</template>
<script>
import { formMultilSelectMixin } from '@/mixins/formMultilSelectMixin'
import EmailLogin from '@/components/sharable/modals/authentication/EmailLogin'

export default {
  mixins: [formMultilSelectMixin],
  components: {
    EmailLogin
  },
  data() {
    return {
      value: '',
      context: null,
      selected: '',
      form: {
        time_to_start: 'Immediately',
        contact_type: 'Email'
      }
    }
  },
  methods: {
    onContext(ctx) {
      this.context = ctx
    },
    changeTimeToStart(value) {
      this.form.time_to_start = value
    },
    changeContactType(value) {
      this.form.contact_type = value
    },
    async processQuery() {
      console.log(this.form, 'form')
    },
    openLoginModal() {
      this.$bvModal.show('login-modal')
    }
  }
}
</script>